(() => {
  if (window.nuraVariantBridgeInitialized) return;
  window.nuraVariantBridgeInitialized = true;

  const normalize = (value) =>
    String(value || '')
      .trim()
      .toLocaleLowerCase()
      .replace(/\s+/g, ' ');

  const getSelectedText = (select) => {
    const selectedOption = select.selectedOptions?.[0];
    return normalize(selectedOption?.textContent || selectedOption?.label || select.value);
  };

  const findMatchingVariantInput = (productInfo, selectedText) => {
    const inputs = Array.from(productInfo.querySelectorAll('variant-selects input[type="radio"]'));

    return inputs.find((input) => {
      const value = normalize(input.value);
      const label = normalize(input.labels?.[0]?.textContent);

      return selectedText === value || selectedText === label || selectedText.startsWith(`${value} `);
    });
  };

  document.addEventListener(
    'change',
    (event) => {
      const select = event.target;
      if (!(select instanceof HTMLSelectElement) || select.closest('variant-selects')) return;

      const productInfo = select.closest('product-info.nura-has-app-purchase-options');
      if (!productInfo) return;

      const matchingInput = findMatchingVariantInput(productInfo, getSelectedText(select));
      if (!matchingInput) return;

      matchingInput.checked = true;
      matchingInput.dispatchEvent(new Event('change', { bubbles: true }));
    },
    true
  );
})();
